import { render, staticRenderFns } from "./AdminDomainForm.vue?vue&type=template&id=7c414202&scoped=true"
import script from "./AdminDomainForm.vue?vue&type=script&lang=ts"
export * from "./AdminDomainForm.vue?vue&type=script&lang=ts"
import style0 from "./AdminDomainForm.vue?vue&type=style&index=0&id=7c414202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c414202",
  null
  
)

export default component.exports